import React from 'react';
import { twMerge } from 'tailwind-merge';
import { Member } from '../types/family';
interface AvatarProps {
  member: Member;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}
const sizes = {
  sm: 'h-7 w-7 text-xs',
  md: 'h-9 w-9 text-sm',
  lg: 'h-11 w-11 text-base'
};
export function Avatar({
  member,
  size = 'md',
  className
}: AvatarProps) {
  return <span className={twMerge('grid shrink-0 place-items-center rounded-full font-extrabold text-white', sizes[size], className)} style={{
    backgroundColor: member.color
  }} aria-hidden="true" data-id="element-3" data-mp="21r9x0oz8azu">
      {member.name.charAt(0)}
    </span>;
}